import request from '../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/hnSsc2/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/hnSsc2/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/hnSsc2/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/hnSsc2/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/hnSsc2/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/hnSsc2/delete/batch', {
    params: {
      ids
    }
  })
}
